import React, { useEffect, useState } from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import AxiosInstance from "../utils/axiosInstance";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const userData = localStorage.getItem("loggedInUserInfo");
  const parsedData = JSON.parse(userData);

  if (userData != null && userData != undefined) {
    const userType = parsedData?.user_type;
    if (userType === "CCN_Internal") {
      navigate("/ccn");
    } else if (userType === "WAH") {
      navigate("/wah");
    } else if (userType === "MRB") {
      navigate("/mrb");
    } else {
      navigate("/dashboard");
    }
  }

  const [wordCount, setWordCount] = useState(0);
  const maxWords = 256;
  const [list, setList] = useState([]);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    inquiry: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    AxiosInstance.get(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_HOME_COUNT}`,
    )
      .then((response) => {
        if (response.data?.data) {
          setList(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    if (name === "inquiry") {
      setWordCount(value.length);
    }
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Form validation
  // 123-456-7890
  // (123) 456-7890
  // 123.456.7890
  // +1 123 456 7890
  // +1 (123) 456-7890
  // 1234567890
  const validateForm = () => {
    const newErrors = {};
    if (!formData.first_name.trim())
      newErrors.first_name = "First name is required.";
    if (!formData.last_name.trim())
      newErrors.last_name = "Last name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }
    if (!formData.phone_number.trim())
      newErrors.phone_number = "Phone number is required.";
    else if (
      !/^(\+1[-.\s]?)?(\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/.test(
        formData.phone_number,
      )
    ) {
      newErrors.phone_number = "Invalid phone number format.";
    }
    if (!formData.inquiry.trim())
      newErrors.inquiry = "Inquiry message is required.";
    return newErrors;
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    AxiosInstance.post(
      `${process.env.REACT_APP_API_URL}/add_contact_lead`,
      formData,
    )
      .then((response) => {
        if (response) {
          toast.success("Message sent successfully!");
          setFormData({
            first_name: "",
            last_name: "",
            email: "",
            phone_number: "",
            inquiry: "",
          });
          setWordCount(0);
        } else {
          toast.error("Something went wrong!");
        }
      })
      .catch((error) => {
        console.error("Error sending message:", error);
        toast.error("Error sending message. Please try again later.");
      });
  };

  return (
    <div>
      <>
        <div className="bg-image">
          <Header />
          <div className="container">
            <div className="row pb-md-20">
              <div className="col-12 col-md-6">
                <h1 className="text-white fw-boldest my-5 py-5 point-52">
                  Search Less.
                  <br />
                  Bid More.
                </h1>
              </div>
              <div className="col-12 col-md-6 d-sm-none d-md-block">&nbsp;</div>
            </div>
          </div>
        </div>
        <div className="bg-primary pb-md-10 z-index-1">
          <div className="container shadow">
            <div className="row">
              <div className="col-12 col-md-6 bg-primary mt-md-n20 z-3">
                <div className="px-45 p-5">
                  <h3 className="text-secondary point-22 fw-normal">
                    Welcome to the
                  </h3>
                  <h2 className="text-white fw-bold point-32">
                    Contractors
                    <br />
                    Communication
                    <br className="d-none d-md-block" />
                    Network
                  </h2>
                  <p className="text-white point-22 py-5">
                    {/* Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat. */}
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-3 mt-md-n20 bg-image-1 px-0 slideup-p z-3">
                <div className="d-flex flex-column justify-content-end h-100">
                  <div className="p-3 bg-secondary w-100 secondary-arrow clearfix">
                    <h4 className="mb-2 text-primary text-uppercase fw-bold point-22">
                      Building
                    </h4>
                    <p className="text-primary point-18">
                      CCN brings city, county, and public agency building
                      projects into one centralized network. Search by work
                      type, opt in to projects that match the work you do, and
                      connect across the network. Spend less time searching —
                      more time bidding.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-3 mt-md-n20 bg-image-2 px-0 slideup-p z-3">
                <div className="d-flex flex-column justify-content-end h-100">
                  <div className="p-3 bg-white w-100 primary-arrow clearfix">
                    <h4 className="mb-2 text-primary text-uppercase fw-bold point-22">
                      Highway
                    </h4>
                    <p className="text-primary point-18">
                      CCN brings DOT, city, and county highway projects into one
                      centralized network. Search by work type, opt in to
                      projects that match the work you do, and connect across
                      the network. Spend less time searching — more time
                      bidding.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-primary">
          <div className="container">
            <div className="row pt-5 pb-5 pb-md-20">
              <div className="col-12 col-md-7 bg-primary">
                <div className="">
                  <h2 className="text-secondary fw-bolder p-0 m-0 point-32 text-center text-md-left mb-5 mb-md-0">
                    Get started and join the network.
                  </h2>
                </div>
              </div>
              <div className="col red-midline d-none d-md-block" />
              <div className="col text-center">
                <div className="">
                  <button
                    type="submit"
                    className="btn btn-secondary rounded-5 fw-bold text-uppercase py-2 px-4 point-18"
                    onClick={() => navigate("/signup")}
                  >
                    Sign Up
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-light pb-10">
          <div className="container">
            <div className="row justify-content-center">
              {list.map((item, index) => (
                <div className="col-12 col-md-3 mt-md-n10 mb-3" key={index}>
                  <div className="p-4 height-100 h-100 bg-white shadow d-flex flex-column justify-content-between">
                    <p className="mb-md-5 text-secondary text-md-end text-center text-uppercase fw-bolder point-md-32">
                      {/* {item.count} */}
                    </p>
                    <p
                      className="text-black pb-4 red-underline fw-normal"
                      style={{
                        wordBreak: "break-word",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        fontSize: "1.50rem",
                      }}
                    >
                      {item.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="bg-light">
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="p-5 text-center">
                  <p className="mb-2 text-primary point-22">All Access From</p>
                  <p className="text-primary fw-bolder point-42">
                    Your Dashboard
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-8 offset-2 offset-md-0 col-md-3">
                <div className="p-3 text-center">
                  <div className="">
                    <div className="rounded-pill bg-secondary ratio ratio-1x1 w-75 mx-auto mb-3">
                      <div className="d-flex flex-column justify-content-center">
                        <div className="py-4 px-3 text-secondary white-outline text-center text-uppercase fw-bolder point-32">
                          <svg
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 200 200"
                          >
                            <defs>
                              <style
                                dangerouslySetInnerHTML={{
                                  __html:
                                    "\n                            .cls-1 {\n                              fill: #fff;\n                              stroke-width: 0px;\n                            }\n                          ",
                                }}
                              />
                            </defs>
                            <path
                              className="cls-1"
                              d="M95.3,82.5v101.1c0,1.7,1.3,3,3,3s3-1.3,3-3v-91.6c-2.4-2.9-4.4-6.1-6-9.5Z"
                            />
                            <path
                              className="cls-1"
                              d="M98.3,186.9c-.5,0-1,0-1.4,0-22.5-.3-43.7-9.3-59.7-25.3-16.4-16.3-25.4-38.1-25.4-61.2s10-46.8,27.3-63.1c0,0,.1-.1.2-.2,15.7-14.7,36.2-22.9,57.7-23.2.4,0,.8,0,1.3,0,1.7,0,3,1.3,3,3s-1.4,3-3.1,3c-.3,0-.7,0-1,0-20.2.3-39.3,8-53.9,21.8,0,0-.1.1-.2.2-16,15.1-25.2,36.5-25.2,58.5s8.4,41.8,23.6,57c14.9,14.9,34.6,23.2,55.6,23.5.5,0,.8,0,1.2,0,.4,0,.8,0,1.1,0,21.1-.3,40.9-8.7,55.8-23.5,15.2-15.2,23.6-35.4,23.6-57s1.3-3,3-3,3,1.3,3,3c0,23.2-9,44.9-25.4,61.2-16,16-37.2,24.9-59.8,25.3-.4,0-.8,0-1.3,0Z"
                            />
                            <path
                              className="cls-1"
                              d="M144.3,109.1c-.9,14.7-4,28.6-9.4,40.5-8.6,19.2-21.6,30.6-35.5,31.2-.4,0-.7,0-1.1,0-.4,0-.8,0-1.1,0-13.9-.6-26.8-12-35.4-31.3-6.4-14.2-9.8-31.2-9.8-49.2s3.9-37.2,10.9-51.7c8.6-17.7,21.1-28.3,34.3-28.8.3,0,.7,0,1,0,1.7,0,3.1-1.3,3.1-3s-1.3-3-3-3-1,0-1.4,0c-15.5.7-29.8,12.4-39.4,32.2-7.4,15.2-11.5,34.5-11.5,54.3s3.6,36.7,10.3,51.7c9.6,21.4,24.4,34.1,40.6,34.8.5,0,.9,0,1.4,0s1,0,1.4,0c16.2-.7,31.1-13.4,40.7-34.8,5.8-12.8,9.1-27.8,9.9-43.7-1.9.4-4,.6-6,.8Z"
                            />
                            <path
                              className="cls-1"
                              d="M98.3,186.9c-.5,0-1,0-1.4,0-22.5-.3-43.7-9.3-59.7-25.3-.7-.7-1-1.6-.9-2.5.1-.9.6-1.7,1.4-2.2,6-3.6,12.8-6.6,20.3-8.9,12.3-3.9,26.2-5.9,40.2-5.9s27.9,2.1,40.2,6c7.5,2.4,14.3,5.4,20.3,8.9.8.5,1.3,1.3,1.4,2.2.1.9-.2,1.8-.9,2.5-16,16-37.2,24.9-59.8,25.3-.4,0-.8,0-1.3,0ZM98.3,180.9c.4,0,.8,0,1.1,0,19.8-.3,38.4-7.6,52.9-20.8-4.7-2.5-9.9-4.6-15.5-6.4-11.7-3.7-25-5.7-38.4-5.7s-26.7,2-38.4,5.7c-5.6,1.8-10.8,3.9-15.6,6.4,14.5,13.1,33.1,20.5,52.7,20.8.5,0,.8,0,1.2,0Z"
                            />
                            <path
                              className="cls-1"
                              d="M89.9,52.4c-10.5-.6-20.7-2.4-30-5.4-5.6-1.8-10.8-3.9-15.5-6.4,14.5-13.1,33.1-20.5,52.9-20.8.3,0,.7,0,1,0,1.7,0,3.1-1.3,3.1-3,0-1.7-1.3-3-3-3s-1,0-1.3,0c-22.6.3-43.8,9.3-59.8,25.3-.7.7-1,1.6-.9,2.5.1.9.6,1.7,1.4,2.2,6,3.6,12.8,6.5,20.3,8.9,9.8,3.1,20.6,5,31.6,5.6,0-2,0-4,.2-6Z"
                            />
                            <path
                              className="cls-1"
                              d="M106.3,97.4H16.8c-1.7,0-3,1.3-3,3s1.3,3,3,3h98.1c-3.1-1.7-6-3.7-8.5-6Z"
                            />
                            <path
                              className="cls-1"
                              d="M185.1,149c-1.1,0-2.1-.6-2.7-1.6l-27.3-48.8c-.8-1.5-.3-3.4,1.2-4.2,1.5-.8,3.4-.3,4.2,1.2l27.3,48.8c.8,1.5.3,3.4-1.2,4.2-.5.3-1,.4-1.5.4Z"
                            />
                            <path
                              className="cls-1"
                              d="M139.8,100.1c-24,0-43.5-19.5-43.5-43.5s19.5-43.5,43.5-43.5,43.5,19.5,43.5,43.5-19.5,43.5-43.5,43.5ZM139.8,19.4c-20.6,0-37.3,16.7-37.3,37.3s16.7,37.3,37.3,37.3,37.3-16.7,37.3-37.3-16.7-37.3-37.3-37.3Z"
                            />
                            <path
                              className="cls-1"
                              d="M139.8,67.5c-8.9,0-16.1-8.4-16.1-18.8s7.2-18.8,16.1-18.8,16.1,8.4,16.1,18.8-7.2,18.8-16.1,18.8ZM139.8,36.2c-5.4,0-9.8,5.6-9.8,12.5s4.4,12.5,9.8,12.5,9.8-5.6,9.8-12.5-4.4-12.5-9.8-12.5Z"
                            />
                            <path
                              className="cls-1"
                              d="M167.6,86.8c-1.7,0-3.1-1.4-3.1-3.1,0-10-6-18.9-15.2-22.8-1.6-.7-2.3-2.5-1.7-4.1.7-1.6,2.5-2.3,4.1-1.7,11.6,4.8,19.1,16,19.1,28.5s-1.4,3.1-3.1,3.1Z"
                            />
                            <path
                              className="cls-1"
                              d="M112.1,86.8c-1.7,0-3.1-1.4-3.1-3.1,0-12.4,7.4-23.6,18.8-28.4,1.6-.7,3.4,0,4.1,1.7.7,1.6,0,3.4-1.7,4.1-9.1,3.9-15,12.8-15,22.7s-1.4,3.1-3.1,3.1Z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-primary point-18 fw-normal">
                    Search The Contractor Network
                  </p>
                </div>
              </div>
              <div className="col-8 offset-2 offset-md-0 col-md-3">
                <div className="p-3 text-center">
                  <div className="">
                    <div className="rounded-pill bg-secondary ratio ratio-1x1 w-75 mx-auto mb-3">
                      <div className="d-flex flex-column justify-content-center">
                        <div className="py-4 px-3 text-secondary white-outline text-center text-uppercase fw-bolder point-32">
                          <svg
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 200 200"
                          >
                            <defs>
                              <style
                                dangerouslySetInnerHTML={{
                                  __html:
                                    "\n                            .cls-1 {\n                              fill: #fff;\n                              stroke-width: 0px;\n                            }\n                          ",
                                }}
                              />
                            </defs>
                            <path
                              className="cls-1"
                              d="M126.7,187c0,0-.1,0-.2,0-1.1,0-2-.7-2.5-1.7l-25.5-52.9c-.7-1.5,0-3.3,1.4-4,1.5-.7,3.3,0,4,1.4l23.3,48.2,13-19.2c.6-.9,1.7-1.4,2.7-1.3l23.1,1.8-23.4-48.5c-.7-1.5,0-3.3,1.4-4,1.5-.7,3.3,0,4,1.4l25.7,53.2c.5,1,.4,2.1-.2,3-.6.9-1.6,1.4-2.7,1.3l-26.6-2-15,22.1c-.6.8-1.5,1.3-2.5,1.3Z"
                            />
                            <path
                              className="cls-1"
                              d="M73.3,187c-1,0-1.9-.5-2.5-1.3l-15-22.1-26.6,2c-1.1,0-2.1-.4-2.7-1.3-.6-.9-.7-2-.2-3l27-56c.7-1.5,2.5-2.1,4-1.4,1.5.7,2.1,2.5,1.4,4l-24.7,51.3,23.1-1.8c1.1,0,2.1.4,2.7,1.3l13,19.2,22.7-47c.7-1.5,2.5-2.1,4-1.4,1.5.7,2.1,2.5,1.4,4l-24.9,51.7c-.5,1-1.4,1.6-2.5,1.7,0,0-.1,0-.2,0Z"
                            />
                            <path
                              className="cls-1"
                              d="M96.4,135.3c-.2,0-.5,0-.7,0-3.8-.3-6.8-2.5-9.5-4.5-1.7-1.2-3.3-2.4-4.7-2.9-1.6-.5-3.6-.6-5.8-.7-3.3,0-7-.2-10-2.2-3.1-2.1-4.5-5.5-5.9-8.5-.8-1.9-1.7-3.8-2.7-5-1.1-1.2-2.8-2.3-4.6-3.4-2.8-1.7-6-3.7-7.6-7-1.6-3.3-1.2-7-.8-10.2.2-2.1.5-4.2.1-5.8-.3-1.5-1.2-3.3-2.2-5.1-1.6-2.9-3.4-6.3-3.1-10,.3-3.8,2.5-6.8,4.5-9.5,1.2-1.7,2.4-3.3,2.9-4.7.5-1.6.6-3.6.7-5.8,0-3.3.2-7,2.2-10,2.1-3.1,5.5-4.5,8.5-5.9,2-.8,3.8-1.6,5-2.7,1.2-1.1,2.3-2.8,3.4-4.6,1.7-2.8,3.7-6,7-7.6,3.3-1.6,7-1.2,10.2-.8,2.1.2,4.2.5,5.8.1,1.5-.3,3.3-1.2,5.1-2.2,2.9-1.6,6.3-3.4,10-3.1,3.8.3,6.8,2.5,9.5,4.5,1.7,1.2,3.3,2.4,4.7,2.9,1.6.5,3.6.6,5.8.7,3.3,0,7,.2,10,2.2,3.1,2.1,4.5,5.5,5.9,8.5.8,2,1.7,3.8,2.7,5,1.1,1.2,2.8,2.3,4.6,3.4,2.8,1.7,6,3.7,7.6,7,1.6,3.3,1.2,7,.8,10.2-.2,2.1-.5,4.2-.1,5.8.3,1.5,1.2,3.3,2.2,5.1,1.6,2.9,3.4,6.3,3.1,10h0c-.3,3.8-2.5,6.8-4.5,9.5-1.2,1.7-2.4,3.3-2.9,4.7-.5,1.6-.6,3.6-.7,5.8,0,3.3-.2,7-2.2,10-2.1,3.1-5.5,4.5-8.5,5.9-1.9.8-3.8,1.7-5,2.7-1.2,1.1-2.3,2.8-3.4,4.6-1.7,2.8-3.7,6-7,7.6-3.3,1.6-7,1.2-10.2.8-2.1-.2-4.2-.5-5.8-.1-1.5.3-3.3,1.2-5.1,2.2-2.7,1.5-5.8,3.2-9.3,3.2ZM78.8,23.9c-1.2,0-2.2.1-3,.5-1.7.9-3.1,3-4.5,5.4-1.3,2.1-2.6,4.3-4.6,6-1.9,1.7-4.3,2.7-6.6,3.7-2.5,1.1-4.9,2.1-6,3.7-1.1,1.6-1.1,4.1-1.2,6.8,0,2.5-.2,5.1-1,7.5-.8,2.4-2.3,4.4-3.8,6.4-1.6,2.2-3.2,4.3-3.3,6.3-.1,2,1.1,4.3,2.4,6.7,1.2,2.2,2.4,4.4,2.8,6.8.5,2.5.2,5.1,0,7.6-.3,2.7-.6,5.2.2,6.9.9,1.7,3,3.1,5.4,4.5,2.1,1.3,4.3,2.6,6,4.6,1.7,1.9,2.7,4.3,3.7,6.6,1.1,2.5,2.1,4.9,3.7,6,1.6,1.1,4.1,1.1,6.8,1.2,2.5,0,5.1.2,7.5,1,2.4.8,4.4,2.3,6.4,3.8,2.2,1.6,4.3,3.2,6.3,3.3,2,.2,4.3-1.1,6.7-2.4,2.1-1.2,4.4-2.4,6.8-2.8,2.5-.5,5.1-.2,7.6,0,2.7.3,5.2.6,6.9-.2,1.7-.9,3.1-3,4.5-5.4,1.3-2.1,2.6-4.3,4.6-6,1.9-1.7,4.3-2.7,6.6-3.7,2.5-1.1,4.9-2.1,6-3.7,1.1-1.6,1.1-4.1,1.2-6.8,0-2.5.2-5.1,1-7.5.8-2.4,2.3-4.4,3.8-6.4,1.6-2.2,3.2-4.3,3.3-6.3h0c.1-2-1.1-4.3-2.4-6.7-1.2-2.2-2.4-4.4-2.8-6.8-.5-2.5-.2-5.1,0-7.6.3-2.7.6-5.2-.2-6.9-.9-1.7-3.1-3.1-5.4-4.5-2.1-1.3-4.3-2.6-6-4.6-1.7-1.9-2.7-4.3-3.7-6.6-1.1-2.5-2.1-4.9-3.7-6-1.6-1.1-4.1-1.1-6.8-1.2-2.5,0-5.1-.2-7.5-1-2.4-.8-4.4-2.3-6.4-3.8-2.2-1.6-4.3-3.2-6.3-3.3-2-.2-4.3,1.1-6.7,2.4-2.2,1.2-4.4,2.4-6.8,2.8-2.5.5-5.1.2-7.6,0-1.4-.2-2.7-.3-3.9-.3ZM158.1,78.3h0,0Z"
                            />
                            <path
                              className="cls-1"
                              d="M80.2,107.8c-.9,0-1.8-.3-2.6-.9-1.6-1.1-2.2-3.2-1.6-5l6.5-20.1-17.1-12.5c-1.6-1.1-2.2-3.2-1.6-5,.6-1.9,2.3-3.1,4.3-3.1h21.2l6.5-20.2c1.2-3.7,7.3-3.7,8.5,0l6.5,20.2h21.2c1.9,0,3.7,1.2,4.3,3.1.6,1.9,0,3.9-1.6,5l-17.1,12.5,6.5,20.1c.6,1.9,0,3.9-1.6,5-1.6,1.1-3.7,1.1-5.3,0l-17.1-12.5-17.1,12.5c-.8.6-1.7.9-2.6.9ZM73.4,67.5l16.5,12-6.3,19.4,16.5-12,16.5,12-6.3-19.3,16.5-12h-20.3l-6.3-19.3-6.3,19.3h-20.3ZM98.3,43h0s0,0,0,0Z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-primary point-18 fw-normal">
                    Access Starred Bid Opportunities
                  </p>
                </div>
              </div>
              <div className="col-8 offset-2 offset-md-0 col-md-3">
                <div className="p-3 text-center">
                  <div className="">
                    <div className="rounded-pill bg-secondary ratio ratio-1x1 w-75 mx-auto mb-3">
                      <div className="d-flex flex-column justify-content-center">
                        <div className="py-4 px-3 text-secondary white-outline text-center text-uppercase fw-bolder point-32">
                          <svg
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 200 200"
                          >
                            <defs>
                              <style
                                dangerouslySetInnerHTML={{
                                  __html:
                                    "\n                            .cls-1 {\n                              fill: #fff;\n                              stroke-width: 0px;\n                            }\n                          ",
                                }}
                              />
                            </defs>
                            <path
                              className="cls-1"
                              d="M54.4,126.1c-.8,0-1.5-.3-2.1-.9l-23.1-23.1c-4.2-4.2-6.7-9.8-7-15.7l-.9-18.9-7.4-7.4c-1.2-1.2-1.2-3.1,0-4.2,1.2-1.2,3.1-1.2,4.2,0l8.2,8.2c.5.5.8,1.2.9,2l1,20.1c.2,4.4,2.1,8.6,5.2,11.7l23.1,23.1c1.2,1.2,1.2,3.1,0,4.2-.6.6-1.4.9-2.1.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M89.2,161c-.8,0-1.6-.3-2.2-1l-.2-.3c-1.1-1.2-1-3.1.2-4.2,1.2-1.1,3.1-1,4.2.2l.2.3c1.1,1.2,1,3.1-.2,4.2-.6.5-1.3.8-2,.8Z"
                            />
                            <path
                              className="cls-1"
                              d="M109.2,177.7c-2.8,0-5.5-1-7.6-3.1l-3.5-3.5c-1.2-1.2-1.2-3.1,0-4.2,1.2-1.2,3.1-1.2,4.2,0l3.5,3.5c2,2,5.6,1.7,7.9-.7,1.2-1.2,1.9-2.7,2-4.3,0-1.5-.4-2.7-1.3-3.6l-3.9-3.9c-1.2-1.2-1.2-3.1,0-4.2,1.2-1.2,3.1-1.2,4.2,0l3.9,3.9c2.1,2.1,3.2,5,3.1,8.2-.2,3.1-1.5,6-3.7,8.2-2.5,2.5-5.7,3.7-8.8,3.7Z"
                            />
                            <path
                              className="cls-1"
                              d="M126.3,169c-2.8,0-5.5-1-7.6-3.1l-4.2-4.2c-1.2-1.2-1.2-3.1,0-4.2,1.2-1.2,3.1-1.2,4.2,0l4.2,4.2c2,2,5.6,1.7,7.9-.7,2.4-2.4,2.7-5.9.7-7.9l-22.9-22.9c-1.2-1.2-1.2-3.1,0-4.2,1.2-1.2,3.1-1.2,4.2,0l22.9,22.9c4.3,4.3,4.1,11.7-.7,16.4-2.5,2.5-5.7,3.7-8.8,3.7Z"
                            />
                            <path
                              className="cls-1"
                              d="M143.1,160.1c-2.8,0-5.5-1-7.6-3.1l-26.9-26.9c-1.2-1.2-1.2-3.1,0-4.2,1.2-1.2,3.1-1.2,4.2,0l26.9,26.9c2,2,5.6,1.7,7.9-.7,2.4-2.4,2.7-5.9.7-7.9l-26.9-26.9c-1.2-1.2-1.2-3.1,0-4.2,1.2-1.2,3.1-1.2,4.2,0l26.9,26.9c4.3,4.3,4,11.7-.7,16.4-2.5,2.5-5.7,3.7-8.8,3.7Z"
                            />
                            <path
                              className="cls-1"
                              d="M151.9,143.3c-2.8,0-5.5-1-7.6-3.1l-22.9-22.9c-1.2-1.2-1.2-3.1,0-4.2,1.2-1.2,3.1-1.2,4.2,0l22.9,22.9c.9.9,2.2,1.4,3.7,1.3,1.6,0,3.1-.8,4.3-2,1.2-1.2,1.9-2.7,2-4.3,0-1.4-.4-2.7-1.3-3.7l-39.2-39.2c-1.2-1.2-1.2-3.1,0-4.2,1.2-1.2,3.1-1.2,4.2,0l39.2,39.2c2.1,2.1,3.2,5.1,3.1,8.2-.2,3-1.5,6-3.7,8.2-2.5,2.5-5.7,3.7-8.8,3.7Z"
                            />
                            <path
                              className="cls-1"
                              d="M100,47.4c-.8,0-1.5-.3-2.1-.9l-5.4-5.4c-3.7-3.7-8.8-5.6-13.9-5.2l-20.5,1.5c-.9,0-1.7-.3-2.3-.9l-9.1-9.1c-1.2-1.2-1.2-3.1,0-4.2s3.1-1.2,4.2,0l8.1,8.1,19.1-1.4c6.9-.5,13.7,2,18.6,6.9l5.4,5.4c1.2,1.2,1.2,3.1,0,4.2-.6.6-1.4.9-2.1.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M151.4,120.4c-.8,0-1.5-.3-2.1-.9-1.2-1.2-1.2-3.1,0-4.2l17.3-17.3c3.1-3.1,5-7.3,5.2-11.7l1-20.1c0-.7.3-1.4.9-2l8.2-8.2c1.2-1.2,3.1-1.2,4.2,0,1.2,1.2,1.2,3.1,0,4.2l-7.4,7.4-.9,18.9c-.3,5.9-2.8,11.5-7,15.7l-17.3,17.3c-.6.6-1.4.9-2.1.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M82.5,163.7c-2.9,0-5.7-1.1-7.8-3.2-2.1-2.1-3.3-5-3.2-8,0-3,1.3-5.8,3.4-8l10.5-10.5c2.2-2.2,5.2-3.5,8.2-3.5s5.7,1.1,7.8,3.2c4.3,4.3,4.2,11.5-.2,16l-10.5,10.5c-2.2,2.2-5.1,3.5-8.2,3.5ZM93.7,136.5c-1.5,0-2.9.6-4,1.7l-10.5,10.5c-1.1,1-1.6,2.4-1.7,3.9,0,1.4.5,2.7,1.4,3.6,2,2,5.4,1.9,7.5-.2l10.5-10.5c2.1-2.1,2.2-5.5.2-7.5-.9-.9-2.2-1.4-3.5-1.4Z"
                            />
                            <path
                              className="cls-1"
                              d="M68.2,154.8c-2.9,0-5.7-1.1-7.8-3.2-2.1-2.1-3.2-4.8-3.2-7.8,0-3.1,1.2-6,3.5-8.2l13.2-13.2c2.2-2.2,5.1-3.4,8.2-3.4s5.7,1.1,7.8,3.2c2.1,2,3.2,4.8,3.2,7.8,0,3.1-1.2,6-3.5,8.3,0,0,0,0,0,0l-13.2,13.2c-2.2,2.2-5.1,3.5-8.2,3.5ZM82.1,125c-1.5,0-2.9.6-4,1.7l-13.2,13.2c-1.1,1.1-1.7,2.5-1.7,4s.5,2.6,1.4,3.5c2,2,5.4,1.8,7.5-.3l13.2-13.2c1.1-1.1,1.7-2.5,1.7-4,0-1.3-.5-2.6-1.4-3.5-.9-.9-2.2-1.4-3.5-1.4ZM87.5,136.1h0,0Z"
                            />
                            <path
                              className="cls-1"
                              d="M96.1,173c-2.9,0-5.7-1.1-7.8-3.2-3.5-3.5-4.2-9-1.8-13.4.5-1,1.2-1.9,2-2.7l8.4-8.4c2.2-2.2,5.1-3.4,8.2-3.4s5.7,1.1,7.8,3.2c4.3,4.4,4.2,11.5-.2,16,0,0,0,0,0,0l-8.4,8.4c-.8.8-1.7,1.5-2.7,2-1.6.9-3.6,1.4-5.5,1.4ZM105.2,148c-1.5,0-2.9.6-4,1.7l-8.4,8.4c-.4.4-.7.8-1,1.3-1.2,2.1-.9,4.6.7,6.2,1.6,1.6,4.2,1.9,6.2.8.5-.3.9-.6,1.3-1l8.4-8.4c2.1-2.1,2.2-5.5.2-7.5-1.2-1.2-2.6-1.4-3.5-1.4ZM110.6,159.1h0,0Z"
                            />
                            <path
                              className="cls-1"
                              d="M72.1,100.5c-5.3,0-10.4-2.1-14.1-5.9-3.4-3.4-3.4-9,0-12.4l45.4-45.4c4.9-4.9,11.7-7.4,18.6-6.9l19.1,1.4,8.1-8.1c1.2-1.2,3.1-1.2,4.2,0,1.2,1.2,1.2,3.1,0,4.2l-9.1,9.1c-.6.6-1.5.9-2.3.9l-20.5-1.5c-5.2-.4-10.3,1.5-13.9,5.2l-45.4,45.4c-1.1,1.1-1.1,2.8,0,3.9,2.6,2.6,6.2,4.1,9.9,4.1s7.3-1.5,9.9-4.1l12.3-12.3c1-1,2.7-1.2,3.9-.3.7.5,18.1,12.9,31.1-.1,1.2-1.2,3.1-1.2,4.2,0,1.2,1.2,1.2,3.1,0,4.2-12.2,12.2-28.2,7.3-36.7,2.1l-10.5,10.5c-3.8,3.8-8.8,5.9-14.1,5.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M59.4,140.6c-3,0-5.7-1.1-7.8-3.2-4.3-4.3-4.2-11.5.2-16l.5-.4,10-10.1c2.2-2.2,5.1-3.4,8.2-3.4s5.7,1.1,7.8,3.2c4.3,4.3,4.2,11.5-.2,16l-10.6,10.6c-2.1,2.1-5.1,3.4-8.2,3.4ZM70.6,113.5c-1.5,0-2.9.6-4,1.7l-10.6,10.6c-2.1,2.1-2.2,5.5-.2,7.5,1.2,1.2,2.6,1.4,3.5,1.4,1.5,0,2.9-.6,4-1.7l.4-.4,10-10.1s0,0,0,0c2.1-2.1,2.2-5.5.2-7.5-1.2-1.2-2.6-1.4-3.5-1.4Z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-primary point-18 fw-normal">
                    Save Priority Contacts
                  </p>
                </div>
              </div>
              <div className="col-8 offset-2 offset-md-0 col-md-3">
                <div className="p-3 text-center">
                  <div className="">
                    <div className="rounded-pill bg-secondary ratio ratio-1x1 w-75 mx-auto mb-3">
                      <div className="d-flex flex-column justify-content-center">
                        <div className="py-4 px-3 text-secondary white-outline text-center text-uppercase fw-bolder point-32">
                          <svg
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 200 200"
                            className="w-75"
                          >
                            <defs>
                              <style
                                dangerouslySetInnerHTML={{
                                  __html:
                                    "\n                            .cls-1 {\n                              fill: #fff;\n                              stroke-width: 0px;\n                            }\n                          ",
                                }}
                              />
                            </defs>
                            <path
                              className="cls-1"
                              d="M177.3,186.2H20.7c-4,0-7.3-3.3-7.3-7.3V33.8c0-4,3.3-7.3,7.3-7.3h158.6c4,0,7.3,3.3,7.3,7.3v143.1c0,5.1-4.2,9.3-9.3,9.3ZM20.7,32.5c-.7,0-1.3.6-1.3,1.3v145.1c0,.7.6,1.3,1.3,1.3h156.6c1.8,0,3.3-1.5,3.3-3.3V33.8c0-.7-.6-1.3-1.3-1.3H20.7Z"
                            />
                            <path
                              className="cls-1"
                              d="M33.3,45.4c-1.7,0-3-1.3-3-3v-25.6c0-1.7,1.3-3,3-3s3,1.3,3,3v25.6c0,1.7-1.3,3-3,3Z"
                            />
                            <path
                              className="cls-1"
                              d="M67.3,45.4c-1.7,0-3-1.3-3-3v-25.6c0-1.7,1.3-3,3-3s3,1.3,3,3v25.6c0,1.7-1.3,3-3,3Z"
                            />
                            <path
                              className="cls-1"
                              d="M101.3,45.4c-1.7,0-3-1.3-3-3v-25.6c0-1.7,1.3-3,3-3s3,1.3,3,3v25.6c0,1.7-1.3,3-3,3Z"
                            />
                            <path
                              className="cls-1"
                              d="M135.3,45.4c-1.7,0-3-1.3-3-3v-25.6c0-1.7,1.3-3,3-3s3,1.3,3,3v25.6c0,1.7-1.3,3-3,3Z"
                            />
                            <path
                              className="cls-1"
                              d="M169.3,45.4c-1.7,0-3-1.3-3-3v-25.6c0-1.7,1.3-3,3-3s3,1.3,3,3v25.6c0,1.7-1.3,3-3,3Z"
                            />
                            <path
                              className="cls-1"
                              d="M183.6,62.2H16.4c-1.7,0-3-1.3-3-3s1.3-3,3-3h167.2c1.7,0,3,1.3,3,3s-1.3,3-3,3Z"
                            />
                            <path
                              className="cls-1"
                              d="M47.8,104.2h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM33.9,98.2h10.9v-10.9h-10.9v10.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M88.7,104.2h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM74.8,98.2h10.9v-10.9h-10.9v10.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M129.6,104.2h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM115.8,98.2h10.9v-10.9h-10.9v10.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M170.5,104.2h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM156.7,98.2h10.9v-10.9h-10.9v10.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M47.8,139.3h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM33.9,133.3h10.9v-10.9h-10.9v10.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M88.7,139.3h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM74.8,133.3h10.9v-10.9h-10.9v10.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M129.6,139.3h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM115.8,133.3h10.9v-10.9h-10.9v10.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M170.5,139.3h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM156.7,133.3h10.9v-10.9h-10.9v10.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M47.8,174.4h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM33.9,168.4h10.9v-10.9h-10.9v10.9Z"
                            />
                            <path
                              className="cls-1"
                              d="M88.7,174.4h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM74.8,168.4h10.9v-10.9h-10.9v10.9Z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-primary point-18 fw-normal">
                    Track Important Dates
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white py-5">
          <div className="container py-5">
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="">
                  <h2 className="text-primary fw-bolder point-32">
                    Want to know more about us?
                  </h2>
                  <p className="point-22">
                    {/* Quis nostrud exercitation ullamco. */}
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="">
                  <form onSubmit={handleSubmit}>
                    <div className="row mb-4">
                      <div className="col">
                        <input
                          type="text"
                          className={`form-control border border-secondary rounded-0 ${
                            errors.first_name ? "is-invalid" : ""
                          }`}
                          placeholder="First name"
                          aria-label="First name"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleInputChange}
                        />
                        {errors.first_name && (
                          <div className="text-danger">{errors.first_name}</div>
                        )}
                      </div>
                      <div className="col">
                        <input
                          type="text"
                          className={`form-control border border-secondary rounded-0 ${
                            errors.last_name ? "is-invalid" : ""
                          }`}
                          placeholder="Last name"
                          aria-label="Last name"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleInputChange}
                        />
                        {errors.last_name && (
                          <div className="text-danger">{errors.last_name}</div>
                        )}
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col">
                        <input
                          type="text"
                          className={`form-control border border-secondary rounded-0 ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          placeholder="Email"
                          aria-label="Email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                        {errors.email && (
                          <div className="text-danger">{errors.email}</div>
                        )}
                      </div>
                      <div className="col">
                        <input
                          type="text"
                          className={`form-control border border-secondary rounded-0 ${
                            errors.phone_number ? "is-invalid" : ""
                          }`}
                          placeholder="Phone Number"
                          aria-label="Phone Number"
                          name="phone_number"
                          value={formData.phone_number}
                          onChange={handleInputChange}
                        />
                        {errors.phone_number && (
                          <div className="text-danger">
                            {errors.phone_number}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col">
                        <textarea
                          className={`form-control form-textarea border border-secondary rounded-0 ${
                            errors.inquiry ? "is-invalid" : ""
                          }`}
                          aria-label="Default select example"
                          id="contactUsMessage"
                          name="inquiry"
                          placeholder="What is the nature of your inquiry?"
                          value={formData.inquiry}
                          onChange={handleInputChange}
                          maxLength={maxWords}
                        />
                        <small
                          id="wordCount"
                          className="font-sm float-end d-block align-right"
                        >
                          {wordCount}/{maxWords}
                        </small>
                        {errors.inquiry && (
                          <div className="text-danger">{errors.inquiry}</div>
                        )}
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-secondary rounded-5 fw-bold text-uppercase point-18"
                    >
                      Contact Us
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    </div>
  );
};

export default Home;
